import type { EventType } from '@cocoonspace/api'
import { useLingui } from '@lingui/react/macro'
import { CopyPlusIcon } from 'lucide-react'

import { CreateEventTypeAction } from '../../create-event-type-action'
import { ScheduleCardActionBtn } from '../../scheduling-card'
import type { LocationSchema } from '../edition/event-type-form'

export const DuplicateAction = ({ eventType }: { eventType: EventType }) => {
	const { t } = useLingui()
	const label = t`Dupliquer`

	return (
		<CreateEventTypeAction
			defaultValues={{
				title: `${eventType.title} ${t`(copie)`}`,
				description: eventType.description ?? '',
				duration: eventType.duration,
				meetingBuffer: eventType.meetingBuffer ?? undefined,
				locale: eventType.locale,
				availabilities: eventType.availabilities,
				bookingWindow: eventType.bookingWindow,
				location: (eventType.location as LocationSchema) ?? undefined,
				conflictCalendarRefs: eventType.conflictCalendarRefs ?? [],
				enabled: eventType.enabled,
			}}
		>
			<ScheduleCardActionBtn
				title={label}
				aria-label={label}
			>
				<CopyPlusIcon />
			</ScheduleCardActionBtn>
		</CreateEventTypeAction>
	)
}
